/**
 * @file
 * A library to randomly select items from an array
 */

/**
 * Pick one random element from an array.
 * @param {array} list - An array of arbitrary elements.
 * @returns {object} Some element from that array.
 */
export default function pickOne(list) {
	const randIndex = Math.floor(list.length * Math.random());
	return list[randIndex];
}



// WEBPACK FOOTER //
// ./src/shared/util/pickOne.js